// Port z partials.js linie 1139-1154 (bindDesktopMega).

export function initDesktopMega() {
  document.querySelectorAll('[data-dm-drill]').forEach((drill) => {
    const subs = drill.querySelectorAll('[data-dm-sub]');
    const items = drill.querySelectorAll('[data-dm-items-for]');
    subs.forEach((sb) => {
      const activate = () => {
        const k = sb.getAttribute('data-dm-sub');
        subs.forEach((x) => x.classList.toggle('dm-sub-active', x === sb));
        items.forEach((b) => b.classList.toggle('hidden', b.getAttribute('data-dm-items-for') !== k));
      };
      sb.addEventListener('mouseenter', activate);
      sb.addEventListener('focus', activate);
      sb.addEventListener('click', activate);
    });
  });
}

// Expose globalnie — nav-hydrate.js woła to po klonowaniu <template> na desktop.
if (typeof window !== 'undefined') {
  window.kbInitDesktopMega = initDesktopMega;
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') initDesktopMega();
  else document.addEventListener('DOMContentLoaded', initDesktopMega);
}
